import * as ActionTypes from "../actions/actionTypes";

const initialState = {
  shipmentNotesNodes:[],
   
};

export default function NotesReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.INITIALIZE_VALUES_NOTES:
        let newState = {...state}
        newState.shipmentNotesNodes =action.payload.hasOwnProperty("shipmentNotesNodes") === true ? action.payload.shipmentNotesNodes : []
        newState.notesLoaded =action.notesLoaded
      return newState 

      case ActionTypes.UPDATE_NOTES_ITEM_STATUS: {
        let newState = {...state}
        newState.shipmentNotesNodes[action.index][action.field] =action.payload
        window.noteUpdated = true
        return newState
    }

    case ActionTypes.ADD_NOTES_ITEM: {
      let newshipmentNotesNodes = state.shipmentNotesNodes.slice();
    
      if (action.payload) {
        const index = newshipmentNotesNodes.findIndex(item => item.noteId === action.payload.noteId);
        
        if (index !== -1) {
          // Update existing record
          newshipmentNotesNodes[index] = { ...newshipmentNotesNodes[index], ...action.payload };
        } else {
          // Add new record
          newshipmentNotesNodes.unshift(action.payload);
        }
      }
    
      return { ...state, shipmentNotesNodes: newshipmentNotesNodes };
    }

    case "DONT_SHOW_NOTES_ITEM" :{
      let newState = {...state}

      newState.notesLoaded =action.value
    return newState 

    }
    default:
      return state;
  }
}
